import { UniversalProvider as Provider } from './UniversalProvider'
export * from './types'
export const UniversalProvider = Provider
export default Provider
